// import { useAppSelector } from '@/application/hooks';
import Loader from '@/components/Loader';
import { useMuiTheme } from '@/config/theme/useMuiTheme';
import { useAuth0 } from '@auth0/auth0-react';

const withWaitForTheme = <TProps extends object>(Component: React.FC<TProps>) => {
  const Comp = (props: TProps) => {
    const { isFetching: isMuiThemeFetching } = useMuiTheme();
    const { isLoading: isAuth0Loading } = useAuth0();
    // const isDbLoading = useAppSelector(state => state.login?.isLoading);

    const loading = isAuth0Loading || isMuiThemeFetching; // || isDbLoading;
    if (loading) {
      return <Loader />;
    }

    return <Component {...props} />;
  };
  return Comp;
};
export default withWaitForTheme;
